import { type Deck, flattenDeck } from "@hali-shares/deck-schema";
import { SlidePreview } from "../../deck/SlidePreview";
import { blockText, chipOf } from "./model";
import type { Target } from "./preflight";

const THUMB_W = 280;

/** Where clicking slide `i` of the deck goes: its block, its section, or the talk details. */
export function targetOfSlide(deck: Deck, i: number): Target {
  const slide = flattenDeck(deck)[i]!;
  if (slide.kind === "block")
    for (const [si, s] of deck.sections.entries()) {
      const bi = s.blocks.findIndex((b) => b.id === slide.blockId);
      if (bi >= 0) return { kind: "block", sectionIndex: si, blockIndex: bi };
    }
  if (slide.kind === "section") {
    const si = deck.sections.findIndex((s) => s.id === slide.sectionId);
    if (si >= 0) return { kind: "section", sectionIndex: si };
  }
  return { kind: "deck" };
}

/** Every slide of the talk at a size you can read, captioned "n · TYPE · title"; click one to edit it. */
export function SlidesGrid({ deck, onOpen }: { deck: Deck; onOpen: (t: Target) => void }) {
  const slides = flattenDeck(deck);
  const captionOf = (i: number) => {
    const t = targetOfSlide(deck, i);
    if (t.kind === "block") {
      const b = deck.sections[t.sectionIndex]!.blocks[t.blockIndex]!;
      return `${chipOf(b.type)} · ${blockText(b)}`;
    }
    if (t.kind === "section") return `SECTION · ${deck.sections[t.sectionIndex]!.title}`;
    return `TITLE · ${deck.title}`;
  };
  return (
    <div className="all-slides-grid">
      {slides.map((_, i) => (
        <button key={i} type="button" className="thumb-btn" onClick={() => onOpen(targetOfSlide(deck, i))}>
          <SlidePreview deck={deck} slideIndex={i} width={THUMB_W} />
          <span className="thumb-caption">
            {i + 1} · {captionOf(i)}
          </span>
        </button>
      ))}
    </div>
  );
}
